import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { useAuthentication } from "../auth";
import { PermissionString } from "../auth/types";
import { getUserPlatformPermissions } from "../portal-api";
import { useActiveOrganizationQuery } from "./";
import { getQueryKeyForOrganization } from "./useActiveOrganizationQuery";

export function useCurrentUserPlatformPermissionsQuery(
  options: Partial<UseQueryOptions<PermissionString[]>> = {},
) {
  const { user } = useAuthentication();
  const { data: organization } = useActiveOrganizationQuery();

  return useUserPlatformPermissionsQuery(user?.id, organization?.id, options);
}

export function useUserPlatformPermissionsQuery(
  userId: number | undefined,
  organizationId: number | undefined,
  options: Partial<UseQueryOptions<PermissionString[]>> = {},
) {
  return useQuery<PermissionString[]>({
    queryKey: [
      ...getQueryKeyForOrganization(organizationId),
      "users",
      userId,
      "platform-permissions",
    ],
    queryFn: async () => {
      if (!userId) throw Error("User not found");
      if (!organizationId) throw Error("Organization not found");
      return getUserPlatformPermissions(userId, organizationId);
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled: !!userId && !!organizationId,
    ...options,
  });
}
